import React, { Component, Fragment } from 'react';
import { PATHS, DETAIL_ACTIONS, FEATURE_FLAGS, DEFAULT_TOUR_PROPERTY, OBJECT_RATE_CODE_TYPE } from "../../../../../constants/Define";
import * as HMS from "../../../common/component/Index";
import * as Func from '../../../../../helpers/functions';
import TranslateButton from '../../../common/component/TranslateButton';
import { isEqual, get, cloneDeep, find, toArray } from 'lodash';
import Wrapper from './../../../common/component/Wrapper';
import Input from "../../../common/component/Input";
import { checkUndefine } from "../../../../../helpers/functions";
import ObjectType from '../../../../../models/ObjectType';
import { Checkbox, Radio, Switch } from 'antd'

const CheckboxGroup = Checkbox.Group


const defaultState = {
    action: DETAIL_ACTIONS.CREATE,
    validation: {},
    isGetItem: false
};

class ObjectTypeDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            isSubmit: false,
            objectType: this.props.objectTypeState.detail.objectType,
            isAvailable: this.props.objectTypeState.detail.objectType.isAvailable || true
        }
    }

    componentDidMount() {
        this.initDetail()
    }
    

    initDetail() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0 && match.params.id) {
            const id = match.params.id;
            this.setState({ action: DETAIL_ACTIONS.UPDATE });
            this.props.getObjectTypeDetail(id);
        }
    }

    componentWillUnmount() {
        this.props.setObjectTypeDetail(new ObjectType())
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.objectTypeState.detail.objectType && !isEqual(nextProps.objectTypeState.detail.objectType, this.props.objectTypeState.detail.objectType)) {
            this.setState({ 
                objectType: nextProps.objectTypeState.detail.objectType, 
                isAvailable: nextProps.objectTypeState.detail.objectType.isAvailable,
                action: nextProps.objectTypeState.detail.objectType.id ? 'UPDATE' : this.state.action 
            });
        }
    }

    render() {
        const { t } =  this.props;
        const { action, isSubmit, validation, isGetItem, objectType } = this.state;

        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent className="siteinfo-detail-page">
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'objectTypes'}
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.objectType.title')}`))
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.objectType.title')}`))
                            }
                            componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                                <TranslateButton
                                    languages={objectType.translations}
                                    current={objectType.languageCode}
                                    validation={validation.languageCode}
                                    onChange={this.onShowTranslate}
                                    onClear={this.onExitTranslate}
                                    defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                    onSelectDefault={language => this.onChange('languageCode', language.code)}
                                    onRemove={this.onRemoveTranslate} />
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            onClickBack={this.onClickBack}
                            backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                            titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                            onChangeActive={e => this.onChangeDetail(e.name, e.value)}
                            submitButtonRight={true}
                            statusActiveName={`isActive`}
                        >
                            <Wrapper className='col-md-12 basic-section'>
                                <HMS.FormWrapperItem>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            isValidation={true}
                                            dataValidation={objectType.code}
                                            validation={validation.code}
                                            labelTitle={t(`item.objectType.code`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                className={`form-control`}
                                                disabled={action === DETAIL_ACTIONS.UPDATE || action === DETAIL_ACTIONS.TRANSLATE}
                                                name={`name`} onChange={(e) => this.onChange('code', e.target.value)}
                                                value={Func.checkUndefine(objectType.code)} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            isValidation={true}
                                            dataValidation={objectType.name}
                                            validation={validation.name}
                                            labelTitle={t(`item.objectType.name`)}
                                        >
                                            <Input placeholder="" type={`text`}
                                                className={`form-control`}
                                                name={`name`} onChange={(e) => this.onChange('name', e.target.value)}
                                                value={Func.checkUndefine(objectType.name)} />
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            isValidation={true}
                                            dataValidation={objectType.description}
                                            validation={validation.description}
                                            labelTitle={t(`item.objectType.description`)}
                                        >
                                            <Input.TextArea rows={3} placeholder="" type={`text`}
                                                className={`form-control`}
                                                name={`description`} onChange={(e) => this.onChange('description', e.target.value)}
                                                value={Func.checkUndefine(objectType.description)} />
                                        </HMS.FormWrapperInputComponent>
                                    
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            isValidation={true}
                                            dataValidation={objectType.types}
                                            validation={validation.types}
                                            labelTitle={t(`item.objectType.types`)}
                                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                        >
                                            <div>
                                                <CheckboxGroup
                                                    // className="m-t"
                                                    options={DEFAULT_TOUR_PROPERTY}
                                                    value={objectType.types || []}
                                                    onChange={this.onChangeCheckBox} />
                                            </div>
                                        </HMS.FormWrapperInputComponent>

                                        <HMS.FormWrapperInputComponent
                                            isRequired={true}
                                            isValidation={true}
                                            dataValidation={objectType.rateCodeType}
                                            validation={validation.rateCodeType}
                                            labelTitle={t(`item.objectType.rateCodeType`)}
                                            visible={action === DETAIL_ACTIONS.CREATE}
                                        >
                                            <div>
                                                <Radio.Group value={action === DETAIL_ACTIONS.CREATE && objectType.rateCodeType == null ? OBJECT_RATE_CODE_TYPE.Single.id : objectType.rateCodeType}
                                                    onChange={(e) => this.onChangeRateCodeType(e.target.value)}>
                                                    {toArray(OBJECT_RATE_CODE_TYPE).map(type => (
                                                        <Radio key={type.id} value={type.id}>{type.label}</Radio>
                                                    ))}
                                                </Radio.Group>
                                            </div>
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                    <Wrapper className="col-md-6">
                                        <HMS.FormWrapperInputComponent
                                            isValidation={true}
                                            dataValidation={this.state.isAvailable}
                                            validation={this.state.isAvailable}
                                            labelTitle={t(`item.objectType.isAvailable`)}
                                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                        >
                                            <div>
                                                <Switch defaultChecked checked={this.state.isAvailable} onChange={this.onCheckAvailable} />
                                            </div>
                                        </HMS.FormWrapperInputComponent>
                                    </Wrapper>
                                </HMS.FormWrapperItem>
                            </Wrapper>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        )
    }

    onCheckAvailable = (checked) => {
        this.setState({ isAvailable: checked });
    }

    onChangeCheckBox = list => {
        const newData = Object.assign(this.state.objectType, { types: list })
        this.setState({ objectType: newData })
    };

    onChangeRateCodeType = list => {
        const newData = Object.assign(this.state.objectType, { rateCodeType: list })
        this.setState({ objectType: newData })
    };

    onSaveTranslate = () => {
        const { objectType } = this.state;
        const translateFunction = objectType.translate.id ? this.props.updateObjectTypeTranslate : this.props.createObjectTypeTranslate;
        translateFunction(objectType, objectType.languageCode);
        this.onExitTranslate();
    }

    onChange = (fieldName, value) => {
        const objectType = this.state.objectType;
        objectType[fieldName] = value.trimLeft();
        this.setState({ objectType });
    };

    onSubmit = (e) => {
        e.preventDefault();
        const { objectType, action, isAvailable } = this.state;
        const newData = Object.assign(objectType, { isAvailable })
        if (this.validate()) {
            if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
                this.onSaveTranslate()
            } else if (action === DETAIL_ACTIONS.CREATE) {
                this.props.createObjectTypeDetail(newData)
            } else {
                this.props.updateObjectTypeDetail({ objectType: newData, props: this.props })
            }
        }
    }

    validate() {
        const { t } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.objectType.name`)),
                code: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.objectType.code`)),
            },
            isCode: { code: t('validation.code') },
            minLength: { types: t('validation.type') },
            maxLength: { code: Func.formatValidation(t('validation.statusCode.code.4'), 5) }
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        let valueValidate = {
            minLength: { types: 1 },
            maxLength: { code: 5 }
        };
        const result = Func.multipleValidate(this.state.objectType, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.OBJECT_TYPES.LIST.path);
        }
    }

    onShowTranslate = (language) => {
        const { objectType } = this.state;
        objectType.setTranslate(language.code);
        objectType.setData();
        this.setState({ objectType, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const objectType = cloneDeep(this.state.objectType);
        const action = DETAIL_ACTIONS[objectType.id ? 'UPDATE' : 'CREATE'];
        objectType.setTranslate(undefined, true);
        objectType.setData();
        this.setState({ objectType, action });
    }

    onSaveTranslate = () => {
        const { objectType } = this.state;
        const translateFunction = objectType.translate.id ? this.props.updateObjectTypeTranslate : this.props.createObjectTypeTranslate;
        translateFunction(objectType, objectType.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { objectType } = this.state;
        objectType.setTranslate(language.code);
        this.props.deleteObjectTypeTranslate(objectType, { id: objectType.id });
    }
}

export default ObjectTypeDetail;
